module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAARCAYAAAF1DcY3AAAAAXNSR0IArs4c6QAAAQ1JREFUOBGFkiEOwlAMhgcJQUyARs0REg5AgkKTILgH4CeQCA4xhcJzB+Qk4QAoBNMLGX8f7UtfN9hLuvbv97cvbESRPhVOhNj7JsSQOkvfoaIjCuSJuuc0RCXAZ/T6XlAhrq4SsXMQwcmcYLryAoW/VjdphPVc9+miM0E6Fgy+bfdcWLhm+AjAP4GBYyMH2PK2IjCgmTCgNLZQWGrBm0luwY1BacFBdgWAhADkURM8AYQfr+ZqaWBBxrfckSct9i+GcYEoeVAS/cDBzwWAMSIXN2d6XeF/126AITVDJM/WF2gYxoiCnOo8USeBUQvALuKiBqTcaF+thmsqTpWvqNs/D0w7NfRCPavd8KPxASGybG83ngynAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/IconEdit.png
// module id = 945
// module chunks = 0